var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("content",null,{"item":{
      interval: _vm.interval.toString(),
      numPresentUsers: _vm.numPresentUsers,
      numTotalUsers: _vm.numTotalUsers,
      usersRate: _vm.usersRate,
      usersRatePercent: (_vm.usersRate * 100).toFixed(2) + '%',
      numBookedDesks: _vm.numBookedDesks,
      numTotalDesks: _vm.numTotalDesks,
      desksRate: _vm.desksRate,
      desksRatePercent: (_vm.desksRate * 100).toFixed(2) + '%',
      numRooms: _vm.numRooms,
    }})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }